/* eslint-disable react/jsx-key */
import { AxiosResponse } from "axios";
import React, { useState } from "react";
import { useTable } from "react-table";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
} from "reactstrap";
import { User } from "../../models/AdminSettingsM/AdminSettingsModel";
import Avatar from "react-avatar";
import { toast } from "react-toastify";
// import UpdateUserForm from "./UpdateUserForm";
import highlightedMenuIcon2 from "../../images/highlightedMenuIcon2.svg";
import menuIcon2 from "../../images/menuIcon2.svg";
import { APP_Config } from "../../utils/AppConfig";
import { HeaderProps } from "react-table";
import { getSettingsEmail } from "../../utils/GeneralUtils";
import Service from "../../services";
import UpdateUserForm from "./UpdateUserForm";

interface AdminSettingsListProps {
  getAllUsersByOrgId: () => void;
  settingsData: User[];
  refresh?: any
}

const AdminSettingsList = (props: AdminSettingsListProps) => {
  const service = new Service();
  const [dropdownToggle, setDropdownToggle] = useState<number>();
  const [createUserModal, setCreateUserModal] = useState(false);
  const [user, setUSer] = useState<User>();

  const openToggle = (index: number) => {
    if (index === dropdownToggle) {
      setDropdownToggle(-1);
    } else {
      setDropdownToggle(index);
    }
  };
  const setUpdateAction = (users: User) => {
    setUSer(users);
    setCreateUserModal(true);
  };

  const updateUserEnableOrDisableSubmit = (Users: User) => {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    updateUserEnableOrDisable(Users);
  };
  const dropDown = (use: User, index: number) => (
    <div className="editDropdown">
      <Dropdown
        toggle={() => openToggle(index)}
        isOpen={index === dropdownToggle}
        className="editdropdown"
      >
        <DropdownToggle data-toggle="dropdown">
          {dropdownToggle !== index ? (
            <img src={menuIcon2} alt="editIcon" />
          ) : (
            <img src={highlightedMenuIcon2} alt="editIcon" />
          )}
        </DropdownToggle>
        <DropdownMenu container="body" className="editMenu">
          <DropdownItem
            onClick={() => {
              setUpdateAction(use);
            }}
          // disabled={user.roles==="CLIENT"}
          >
            Update
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem
            disabled={use.status === "Active"}
            onClick={() => {
              updateUserEnableOrDisableSubmit(use);
            }}
          >
            Enable
          </DropdownItem>
          <DropdownItem divider />

          <DropdownItem
            disabled={use.status === "Deleted"}
            onClick={() => {
              updateUserEnableOrDisableSubmit(use);
            }}
          >
            Disable
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
  const data: any[] = React.useMemo(() => {
    const items = props.settingsData.map((userKey: any, index: number) => ({
      userId: userKey.userId,
      name: userKey?.firstName && userKey?.lastName ?
        `${userKey.firstName} ${userKey.lastName}` :
        "--",

      username: userKey.username || "- -",
      email: getSettingsEmail(userKey.email) || "- -",
      lastaction: userKey?.lastaction ? userKey?.lastaction : "- -",
      role: userKey.role,
      edit: <>{dropDown(userKey, index)}</>,
      avatar: (
        <Avatar
          className="avatarCell"
          round
          size="30px"
          textSizeRatio={2}
          textMarginRatio={0.02}
          name={userKey.firstName + " " + userKey.lastName}
          maxInitials={2}
        />
      ),
    }));
    return items;
  }, [props.settingsData, dropdownToggle]);

  const closeToggle = () => {
    setCreateUserModal(false);
  };
  const updateUserEnableOrDisable = (userkey: User) => {
    const postValue = userkey?.status === "Deleted" ? false : true;
    service
      .updateUserEnableOrDisable(userkey.userId, postValue)
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          toast.success(response.data);
          closeToggle();
          props.getAllUsersByOrgId();
        } else {
          toast.error(response.data);
        }
      })
      .catch((error: any) => {
        toast.error(error.response.data.Errormessage);
      });
  };

  const columns: any = React.useMemo(
    () => [
      {
        Header: "",
        accessor: "avatar",
      },
      {
        Header: "Name",
        accessor: "name", // accessor is the "key" in the data
      },
      {
        Header: "User Name",
        accessor: "username",
      },
      {
        Header: "Email",
        accessor: "email",
        // width:'200px'
      },
      {
        Header: " Last Active",
        accessor: "lastaction",
      },
      {
        Header: "Role",
        accessor: "role",
      },
      {
        Header: "",
        accessor: "edit",
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });

  return (
    <div className="adminSettingsListView">
      <table {...getTableProps()} className="viewTable">
        <thead>
          {headerGroups.map((headerGroup: any) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column: any) => (
                <th
                  {...column.getHeaderProps()}
                  style={{
                    background: "aliceblue",
                    color: "black",
                    fontWeight: "bold",
                  }}
                >
                  <span
                    className="pointer-cursor"
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    onClick={() => setTimeout(() => { }, 10)}
                  >
                    {column.render("Header")}{" "}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows?.map((row: any) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell: any) => {
                  return (
                    <td
                      {...cell.getCellProps()}
                      style={{
                        padding: "10px",
                        border: "solid 1px gray",
                        // width:cell?.column?.width
                      }}
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* update user modal */}
      <Modal
        fade={false}
        isOpen={createUserModal}
        toggle={() => setCreateUserModal((prev) => !prev)}
        className="modalUpdate"
      >
        {
          <UpdateUserForm
            setCreateUserModal={setCreateUserModal}
            closeToggle={closeToggle}
            user={user}
            getAllUsersByOrgId={props.getAllUsersByOrgId}
          />
        }
      </Modal>
    </div>
  );
};

export default AdminSettingsList;
